/* ============================================================
   Cordelo — Correlón™ · scripts propios (prefijo cr-)
   Se incluye desde varias secciones: el guardián evita dobles inicios.
   ============================================================ */
(function () {
  if (window.__crIniciado) return;
  window.__crIniciado = true;

  function listo(fn) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); }
  function formatear(centavos) { return '$' + Math.round(centavos / 100).toLocaleString('es-CO'); }
  function pesos(n) { return '$' + Math.round(n).toLocaleString('es-CO'); }

  /* Cada bloque corre por separado: si uno falla, los demás (por ejemplo el botón flotante) igual funcionan. */
  function seguro(nombre, fn) { try { fn(); } catch (e) { if (window.console) console.error("cr-init " + nombre, e); } }
  listo(function () {
    seguro("initReveals", initReveals);
    seguro("initCalculadora", initCalculadora);
    seguro("initGaleria", initGaleria);
    seguro("initPaquetes", initPaquetes);
    seguro("initSincronizarAlAbrirReleasit", initSincronizarAlAbrirReleasit);
    seguro("initPagoTarjeta", initPagoTarjeta);
    seguro("initLimpiarAntesDeReleasit", initLimpiarAntesDeReleasit);
    seguro("initContador", initContador);
    seguro("initTabs", initTabs);
    seguro("initCarruseles", initCarruseles);
    seguro("initCifras", initCifras);
    seguro("initIrComprar", initIrComprar);
    seguro("initBotonFijo", initBotonFijo);
    seguro("initBotonFlotante", initBotonFlotante);
    seguro("initVideosAuto", initVideosAuto);
  });

  /* ---------- Reveals ---------- */
  function initReveals() {
    var els = document.querySelectorAll('.cr-reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('cr-visible'); }); return;
    }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('cr-visible'); io.unobserve(e.target); } });
    }, { threshold: 0.1, rootMargin: '0px 0px -30px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Calculadora del problema ---------- */
  function initCalculadora() {
    document.querySelectorAll('[data-cr-calc]').forEach(function (calc) {
      var filas = calc.querySelectorAll('[data-cr-calc-fila]');
      var totalEl = calc.querySelector('[data-cr-calc-total]');
      var ahorroEl = calc.querySelector('[data-cr-calc-ahorro]');
      var solucion = parseFloat(calc.getAttribute('data-precio-producto') || '0');
      function recalcular() {
        var total = 0;
        filas.forEach(function (f) {
          var n = parseInt(f.querySelector('[data-cr-cant]').textContent, 10) || 0;
          total += n * (parseFloat(f.getAttribute('data-precio')) || 0) * (parseInt(f.getAttribute('data-por-anio'), 10) || 1);
        });
        if (totalEl) totalEl.textContent = pesos(total);
        if (ahorroEl) {
          var ahorro = Math.max(0, total - solucion);
          ahorroEl.hidden = ahorro <= 0;
          ahorroEl.innerHTML = (ahorroEl.getAttribute('data-plantilla') || '{x}').replace('{x}', '<span>' + pesos(ahorro) + '</span>');
        }
      }
      filas.forEach(function (f) {
        var out = f.querySelector('[data-cr-cant]');
        f.querySelector('[data-cr-menos]').addEventListener('click', function () { out.textContent = Math.max(0, (parseInt(out.textContent, 10) || 0) - 1); recalcular(); });
        f.querySelector('[data-cr-mas]').addEventListener('click', function () { out.textContent = Math.min(20, (parseInt(out.textContent, 10) || 0) + 1); recalcular(); });
      });
      recalcular();
    });
  }

  /* ---------- Galería: carrusel deslizable + miniaturas ----------
     El deslizamiento funciona solo con CSS (aunque este script fallara).
     Las miniaturas mueven el carrusel y se marcan según la foto visible. */
  function initGaleria() {
    var g = document.querySelector('[data-cr-galeria]');
    if (!g || g.__crListo) return;
    g.__crListo = true;
    var track = g.querySelector('[data-cr-track]');
    var slides = Array.prototype.slice.call(g.querySelectorAll('[data-cr-slide]'));
    var minis = Array.prototype.slice.call(g.querySelectorAll('[data-cr-mini]'));
    var contador = g.querySelector('[data-cr-contador-fotos]');
    if (!track || slides.length < 2) return;
    var actual = 0;
    function marcar(i) {
      actual = i;
      minis.forEach(function (m, k) { m.classList.toggle('cr-activa', k === i); });
      if (contador) contador.textContent = (i + 1) + '/' + slides.length;
      var m = minis[i], cont = m && m.parentElement;
      if (m && cont) cont.scrollLeft = Math.max(0, m.offsetLeft - (cont.clientWidth - m.offsetWidth) / 2);
    }
    function ir(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollLeft = slides[i].offsetLeft - track.offsetLeft;
      marcar(i);
    }
    minis.forEach(function (m, k) { m.addEventListener('click', function (e) { e.preventDefault(); ir(k); }); });
    var t = null;
    track.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () { var i = Math.round(track.scrollLeft / track.clientWidth); if (i !== actual) marcar(i); }, 60);
    }, { passive: true });
  }
  /* En el editor de Shopify las secciones se vuelven a dibujar: se reinicia la galería. */
  document.addEventListener('shopify:section:load', function () { initGaleria(); });

  /* ---------- Paquetes ↔ Releasit ---------- */
  function initPaquetes() {
    var raiz = document.querySelector('[data-cr-producto]');
    if (!raiz) return;
    var radios = Array.prototype.slice.call(raiz.querySelectorAll('[data-cr-paquete]'));
    if (!radios.length) return;
    var cantidadInput = raiz.querySelector('[data-cr-cantidad]');
    var ahorroEl = raiz.querySelector('[data-cr-ahorro]');
    var ahorroTxt = raiz.querySelector('[data-cr-ahorro-txt]');
    var sincronizando = false;

    function aplicar(radio, tocarReleasit) {
      radios.forEach(function (r) {
        r.checked = r === radio;
        var card = r.closest('[data-cr-paquete-card]');
        if (card) card.classList.toggle('cr-activa', r === radio);
      });
      var cantidad = radio.value;
      if (cantidadInput) cantidadInput.value = cantidad;
      raiz.crCantidad = parseInt(cantidad, 10);
      var ahorro = parseInt(radio.getAttribute('data-ahorro') || '0', 10);
      if (ahorroEl) {
        ahorroEl.hidden = !(ahorro > 0);
        if (ahorroTxt) ahorroTxt.innerHTML = (ahorroEl.getAttribute('data-plantilla') || '{x}').replace('{x}', '<b>' + formatear(ahorro) + '</b>');
      }
      if (tocarReleasit && !sincronizando) {
        var inp = document.getElementById('quantity_offer_' + (parseInt(cantidad, 10) - 1));
        var label = inp ? inp.closest('label') : null;
        if (label) { sincronizando = true; label.click(); setTimeout(function () { sincronizando = false; }, 80); }
      }
    }
    radios.forEach(function (r) { r.addEventListener('change', function () { aplicar(r, true); }); });
    aplicar(radios.filter(function (r) { return r.checked; })[0] || radios[0], false);

    document.addEventListener('click', function (e) {
      if (sincronizando) return;
      var label = e.target.closest && e.target.closest('label[for^="quantity_offer_"]');
      if (!label) return;
      var intentos = 0;
      var t = setInterval(function () {
        intentos++;
        for (var i = 0; i < 3; i++) {
          var inp = document.getElementById('quantity_offer_' + i);
          if (inp && inp.checked) {
            var r = radios.filter(function (x) { return x.value === String(i + 1); })[0];
            if (r && !r.checked) aplicar(r, false);
            clearInterval(t); return;
          }
        }
        if (intentos > 20) clearInterval(t);
      }, 150);
    }, true);
  }

  function initSincronizarAlAbrirReleasit() {
    var raiz = document.querySelector('[data-cr-producto]');
    if (!raiz || !raiz.querySelector('[data-cr-paquete]')) return;
    var abierto = false, espera = null;
    function forzar() {
      var r = raiz.querySelector('[data-cr-paquete]:checked');
      if (!r) return;
      var inp = document.getElementById('quantity_offer_' + (parseInt(r.value, 10) - 1));
      if (!inp || inp.checked) return;
      var label = inp.closest('label');
      if (label) label.click();
    }
    new MutationObserver(function () {
      clearTimeout(espera);
      espera = setTimeout(function () {
        var ahora = !!document.getElementById('quantity_offer_0');
        if (ahora && !abierto) { var n = 0; var t = setInterval(function () { forzar(); if (++n >= 8) clearInterval(t); }, 100); }
        abierto = ahora;
      }, 60);
    }).observe(document.body, { childList: true, subtree: true });
  }

  /* ---------- Carrito: solo el Correlón ---------- */
  function quitarOtros(idConservar) {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      var updates = {};
      (cart.items || []).forEach(function (it) { if (it.variant_id !== idConservar) updates[it.variant_id] = 0; });
      if (!Object.keys(updates).length) return cart;
      return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ updates: updates }) });
    });
  }

  /* Pago con tarjeta: escucha el CLIC del botón propio (nunca el submit
     del formulario, que comparte con Releasit) y va directo al pago. */
  function initPagoTarjeta() {
    var boton = document.querySelector('[data-cr-tarjeta]');
    if (!boton) return;
    var raiz = boton.closest('[data-cr-producto]');
    var form = boton.closest('form');
    var span = boton.querySelector('span');
    var textoInicial = span ? span.textContent : boton.textContent;
    var cargando = (raiz && raiz.getAttribute('data-texto-cargando')) || 'Un momento…';
    var ocupado = false;
    function texto(t) { if (span) span.textContent = t; else boton.textContent = t; }
    function reactivar() { ocupado = false; boton.disabled = false; texto(textoInicial); }
    function error(msg) {
      var pf = form.closest('product-form');
      var wrap = pf ? pf.querySelector('.product-form__error-message-wrapper') : null;
      if (wrap) { wrap.hidden = false; var m = wrap.querySelector('.product-form__error-message'); if (m) m.textContent = msg; }
    }
    boton.addEventListener('click', function (e) {
      e.preventDefault();
      if (ocupado) return;
      ocupado = true; boton.disabled = true; texto(cargando);
      var id = parseInt(form.querySelector('input[name="id"]').value, 10);
      var qty = (raiz && raiz.crCantidad) || 1;
      quitarOtros(-1)
        .then(function () { return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: qty }] }) }); })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'No se pudo añadir'); return j; }); })
        .then(function () { window.location.href = '/checkout'; })
        .catch(function (err) { reactivar(); error(err.message || 'Algo falló, inténtalo de nuevo.'); });
    });
    window.addEventListener('pageshow', function (ev) { if (ev.persisted) reactivar(); });
  }

  /* Contraentrega (Releasit): antes de continuar, quitar del carrito otros
     productos para que el pedido no llegue mezclado a Dropi. */
  function initLimpiarAntesDeReleasit() {
    var form = document.querySelector('form[data-cr-form]');
    if (!form) return;
    var permitir = false, trabajando = false;
    document.addEventListener('click', function (e) {
      if (permitir) return;
      var boton = null;
      document.querySelectorAll('#rsi_buy_now_button').forEach(function (b) { if (b.contains(e.target)) boton = b; });
      if (!boton) return;
      e.preventDefault(); e.stopImmediatePropagation();
      if (trabajando) return;
      trabajando = true;
      var id = parseInt(form.querySelector('input[name="id"]').value, 10);
      function pasar() { permitir = true; boton.click(); permitir = false; trabajando = false; }
      quitarOtros(id).then(pasar, pasar);
    }, true);
  }

  /* ---------- Contador hasta la hora de corte ---------- */
  function initContador() {
    var t = document.querySelector('[data-cr-timer]');
    if (!t) return;
    var raiz = t.closest('[data-cr-producto]');
    var hora = parseInt((raiz && raiz.getAttribute('data-hora-corte')) || '15', 10);
    var reloj = t.querySelector('[data-cr-timer-reloj]');
    var antes = t.querySelector('[data-cr-timer-antes]');
    var tarde = t.querySelector('[data-cr-timer-tarde]');
    function dos(n) { return (n < 10 ? '0' : '') + n; }
    function tic() {
      /* Cuenta hasta el PRÓXIMO despacho diario: hoy a la hora indicada, o mañana si ya pasó. */
      var ahora = new Date(), corte = new Date(ahora); corte.setHours(hora, 0, 0, 0);
      if (corte <= ahora) corte.setDate(corte.getDate() + 1);
      var s = Math.floor((corte - ahora) / 1000);
      antes.hidden = false; tarde.hidden = true;
      reloj.textContent = dos(Math.floor(s / 3600)) + ':' + dos(Math.floor(s % 3600 / 60)) + ':' + dos(s % 60);
    }
    tic(); setInterval(tic, 1000);
  }

  /* ---------- Pestañas ---------- */
  function initTabs() {
    document.querySelectorAll('[data-cr-tabs]').forEach(function (t) {
      var btns = t.querySelectorAll('[data-cr-tab]'), panels = t.querySelectorAll('[data-cr-panel]');
      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          var i = b.getAttribute('data-cr-tab');
          btns.forEach(function (x) { x.classList.toggle('cr-activa', x === b); });
          panels.forEach(function (p) { p.hidden = p.getAttribute('data-cr-panel') !== i; });
        });
      });
    });
  }

  /* ---------- Carrusel de reseñas ---------- */
  function initCarruseles() {
    document.querySelectorAll('[data-cr-carrusel]').forEach(function (c) {
      var sec = c.closest('section');
      function paso() { return c.children[0] ? c.children[0].getBoundingClientRect().width + 12 : 300; }
      var prev = sec && sec.querySelector('[data-cr-carrusel-prev]');
      var next = sec && sec.querySelector('[data-cr-carrusel-next]');
      if (prev) prev.addEventListener('click', function () { c.scrollBy({ left: -paso(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { c.scrollBy({ left: paso(), behavior: 'smooth' }); });
      var seg = parseInt(c.getAttribute('data-velocidad') || '0', 10);
      if (!seg || c.children.length < 2) return;
      var pausa = false;
      c.addEventListener('touchstart', function () { pausa = true; }, { passive: true });
      setInterval(function () {
        if (pausa) return;
        if (c.scrollLeft + c.clientWidth >= c.scrollWidth - 4) c.scrollTo({ left: 0, behavior: 'smooth' });
        else c.scrollBy({ left: paso(), behavior: 'smooth' });
      }, seg * 1000);
    });
  }

  /* ---------- Cifras animadas ---------- */
  function initCifras() {
    var els = document.querySelectorAll('[data-cr-contador]');
    if (!els.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        var fin = parseFloat(e.target.getAttribute('data-cr-contador')) || 0, t0 = null;
        function paso(t) { if (!t0) t0 = t; var p = Math.min(1, (t - t0) / 1300); e.target.textContent = Math.round(fin * (1 - Math.pow(1 - p, 3))); if (p < 1) requestAnimationFrame(paso); }
        requestAnimationFrame(paso);
      });
    }, { threshold: 0.5 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Botones que llevan a comprar ---------- */
  function initIrComprar() {
    document.querySelectorAll('[data-cr-ir-comprar]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var ancla = document.getElementById('cr-comprar');
        if (!ancla) return;
        e.preventDefault();
        ancla.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  /* ---------- Botón fijo: visible cuando los paquetes no están en pantalla ---------- */
  function initBotonFijo() {
    var fijo = document.querySelector('[data-cr-fijo]');
    var ancla = document.querySelector('.cr-form');
    if (!fijo || !ancla || !('IntersectionObserver' in window)) return;
    var paquetes = document.getElementById('cr-comprar');
    var visibles = new Set();
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) visibles.add(e.target); else visibles.delete(e.target); });
      fijo.classList.toggle('cr-visible', visibles.size === 0);
    });
    io.observe(ancla);
    if (paquetes) io.observe(paquetes);
  }

  /* ---------- Botón flotante a la derecha ("Lo quiero"): lleva a las ofertas ----------
     Visible solo después de pasar los botones de compra. Al tocarlo
     baja a los paquetes para que elija contraentrega o pago en línea. */
  function initBotonFlotante() {
    var boton = document.querySelector("[data-cr-flotante]");
    if (!boton) return;
    var form = document.querySelector(".cr-form");
    var paquetes = document.getElementById("cr-comprar");
    /* Solo aparece cuando el cliente ya BAJÓ más allá de los botones de pago
       del producto (no al entrar a la página). */
    /* Aparece apenas la persona empieza a bajar y se esconde mientras el botón de contraentrega
       (o el regalo que va encima) está en pantalla; después de pasarlo vuelve a aparecer. */
    function objetivo() {
      var r = null;
      document.querySelectorAll("#rsi_buy_now_button").forEach(function (b) { if (!r && !b.classList.contains("rsi_floating") && b.closest("form[data-cr-form], .cr-compra")) r = b; });
      return r || form || paquetes;
    }
    /* El botón aparece cuando en pantalla se ve el texto de debajo del título del gancho
       ("El Correlón se mueve solo… Por fin uno que no ignora") y se esconde mientras el botón
       PAGAR CONTRAENTREGA esté a la vista (nunca los dos a la vez). Cuando ese botón sale por arriba,
       vuelve a aparecer. */
    function revisar() {
      var texto = document.querySelector(".cr-ganc .cr-sub") || document.querySelector(".cr-ganc-video");
      var visto = true;
      if (texto) visto = texto.getBoundingClientRect().bottom < innerHeight;
      var ref = objetivo();
      var codEnPantalla = false;
      if (ref) { var rc = ref.getBoundingClientRect(); codEnPantalla = rc.height > 0 && rc.top < innerHeight && rc.bottom > 0; }
      boton.classList.toggle("cr-visible", visto && !codEnPantalla);
    }
    var pendiente = false;
    window.addEventListener("scroll", function () {
      if (pendiente) return;
      pendiente = true;
      requestAnimationFrame(function () { pendiente = false; revisar(); });
    }, { passive: true });
    window.addEventListener("resize", revisar);
    window.addEventListener("touchmove", function () { requestAnimationFrame(revisar); }, { passive: true });
    window.addEventListener("load", revisar);
    setInterval(revisar, 400);
    revisar();
    boton.addEventListener("click", function () {
      if (paquetes) paquetes.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  }

  /* ---------- Videos: se reproducen sin sonido al llegar a ellos y se pausan al salir ----------
     Algunos celulares (iPhone en ahorro de batería, ahorro de datos) bloquean la
     reproducción automática; en ese caso arrancan con el primer toque en la página. */
  function initVideosAuto() {
    var videos = Array.prototype.slice.call(document.querySelectorAll("video.cr-video-auto, .cd-vit video, .cr-ugc video"));
    if (!videos.length) return;
    function preparar(v) { v.muted = true; v.defaultMuted = true; v.playsInline = true; v.setAttribute("playsinline", ""); v.setAttribute("webkit-playsinline", ""); v.loop = true; }
    function reproducir(v) { preparar(v); var p = v.play(); if (p && p.catch) p.catch(function () { v.addEventListener("loadeddata", function () { var r = v.getBoundingClientRect(); if (v.paused && r.bottom > 0 && r.top < innerHeight) { var q = v.play(); if (q && q.catch) q.catch(function () {}); } }, { once: true }); }); }
    videos.forEach(function (v) { preparar(v); v.removeAttribute("autoplay"); v.pause(); });
    if (!("IntersectionObserver" in window)) { videos.forEach(reproducir); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) reproducir(e.target); else e.target.pause(); });
    }, { threshold: 0.35 });
    videos.forEach(function (v) { io.observe(v); });
    function desbloquear() {
      videos.forEach(function (v) { var r = v.getBoundingClientRect(); if (r.bottom > 0 && r.top < innerHeight && v.paused) reproducir(v); });
    }
    /* iOS solo cuenta como gesto el touchend/click; se reintenta en cada gesto y al hacer scroll hasta que arranquen. */
    ["touchend", "click", "scroll"].forEach(function (ev) { window.addEventListener(ev, desbloquear, { passive: true }); });
    document.addEventListener("visibilitychange", function () { if (!document.hidden) desbloquear(); });
  }
})();
